import { cn } from "@/lib/utils"

interface ComingSoonBadgeProps {
  className?: string
  label?: string
}

export function ComingSoonBadge({ className, label = "Coming Soon" }: ComingSoonBadgeProps) {
  return (
    <span className={cn("rounded-full border border-border/50 px-3 py-1 uppercase tracking-[0.2em]", className)}>
      {label}
    </span>
  )
}


